import React, { useEffect, useState } from 'react';
import { Box, Breadcrumbs, CircularProgress, Link, Typography } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { getRouteWithParam, ROUTES } from '../../../../constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import { getHistory, getTriggers } from '../../../../store/logging/actions';
import {
  getBonusesCompany,
  getBonusesBranches,
  getCmsPackages,
  getEventById,
  getTriggers as getBonusTypes
} from '../../../../store/bonuses/actions';
import { HISTORY_HEAD_CELLS } from '../../constants';
import EnhancedTable from '../../../../components/EnhancedTable';
import { HistoryTableBody } from '../../components/HistoryTableBody';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';
import { PERMISSIONS } from '../../../../constants/variables';
import { setUsersPermissions } from '../../../../utils/setUsersPermissions';

export const EventsHistory = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { history, fetching, triggers } = useSelector((state) => state.logging);
  const { eventCard, fetching: fetchingCard, companyBonuses, triggers: bonusTypes, cms } = useSelector((state) => state.bonuses);
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  const [filter, setFilter] = useState({
    orderBy: 'created_at',
    orderType: 'desc',
    page: 0,
    size: 20,
  });

  useEffect(() => {
    dispatch(getHistory({
      ...filter,
      page: filter.page + 1,
      order_type: filter.orderType,
      order_by: filter.orderBy,
      instance_id: id
    }));  // eslint-disable-next-line
  }, [
    filter.page,
    filter.orderType,
    filter.orderBy,
    filter.size
  ]);

  useEffect(() => {
    if (!Object.keys(eventCard).length) dispatch(getEventById(id));
    if (!companyBonuses?.length) dispatch(getBonusesCompany());
    dispatch(getBonusesBranches({ actual: true }));
    if (!triggers?.length) dispatch(getTriggers());
    if (!bonusTypes?.length) dispatch(getBonusTypes());
    if (!cms?.length) dispatch(getCmsPackages());
  }, // eslint-disable-next-line
    []);

  const isPageVisible =
    visibleBySectionPermission(permissions, [PERMISSIONS.BONUS.ListBonusCards.value, PERMISSIONS.BONUS.CreateBonusCards.value], 'or') &&
    visibleBySectionPermission(permissions, PERMISSIONS.LOGGING.ListHistory.value);

  if (!isPageVisible) {
    return <></>;
  }

  if (!history.items || !Object.keys(eventCard).length) {
    return (
      <Box
        sx={{
          marginTop: '150px',
          textAlign: 'center'
        }}>
        <CircularProgress data-testid="CircularProgress" />
      </Box>
    );
  }

  return (
    <Box>
      <Breadcrumbs mb="24px" aria-label="breadcrumb">
        <Link component={RouterLink} underline="hover" color="inherit" to={ROUTES.BONUSES}>
          Бонусы
        </Link>
        <Link component={RouterLink} underline="hover" color="inherit" to={getRouteWithParam(ROUTES.BONUSES_DETAIL_EVENT, ':id', id)}>
          {eventCard.service.name}
        </Link>
        <Typography>История событий</Typography>
      </Breadcrumbs>
      <EnhancedTable
        rows={history?.items}
        headCells={HISTORY_HEAD_CELLS}
        filter={filter}
        total={history?.total || 0}
        fetching={fetching || fetchingCard}
        heightRow={77}
        setFilter={setFilter}
      >
        <HistoryTableBody data={history.items} />
      </EnhancedTable>
    </Box>
  );
};
